export default "__VITE_ASSET__C6Jruz6o__"